// Address schema property keys
export const streetAddressKey = 'streetAddress'
export const unitNumberKey = 'unitNumber'
export const attentionKey = 'attention'
export const cityKey = 'city'
export const stateKey = 'state'
export const postalCodeKey = 'postalCode'
export const countryKey = 'countryId'
export const address2Key = 'address2'
export const address3Key = 'address3'
export const address4Key = 'address4'

export const streetAddressLabel = 'Street Address'
export const unitNumberLabel = 'Unit Number'
export const attentionLabel = 'Attention'
export const cityLabel = 'City / Town'
export const stateLabel = 'State / Province'
export const postalCodeLabel = 'ZIP / Postal Code'
export const countryLabel = 'Country'
export const address2Label = 'Street Address - Line 1'
export const address3Label = 'Street Address - Line 2'
export const address4Label = 'Street Address - Line 3'

export const addressFormKey = 'address'
export const extendedAddressFormKey = 'extendedAddressForm'
